/** @format */
import {styled, Theme} from '@mui/material/styles';
import {Box} from '@mui/material';

import {StatusVariantType} from 'pages/HomeGrouping/types';

const PREFIX = 'HomeProjectStatus';

const classes = {
  root: `${PREFIX}-root`,
  title: `${PREFIX}-title`,
  helpIcon: `${PREFIX}-helpIcon`,
  helpBox: `${PREFIX}-helpBox`,
  rootError: `${PREFIX}-rootError`,
  rootWarning: `${PREFIX}-rootWarning`,
};

interface StyledProps {
  colorscheme: StatusVariantType;
  theme?: Theme;
}

const getColor = ({colorscheme, theme}: StyledProps) => {
  switch (colorscheme) {
    case 'error':
      return theme?.palette.figma_red_3?.main;
    case 'warning':
      return theme?.palette.figma_yellow?.main;
    default:
      return theme?.palette.figma_gray_dark_2?.main;
  }
};

const getHoverColor = ({colorscheme, theme}: StyledProps) => {
  switch (colorscheme) {
    case 'error':
      return theme?.palette.figma_red_4?.main;
    case 'warning':
      return theme?.palette.figma_yellow_alt?.main;
    default:
      return theme?.palette.figma_gray_dark_3?.main;
  }
};

const Root = styled(Box)(({theme, colorscheme}: StyledProps) => ({
  [`& .${classes.root}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: theme?.spacing(1.5),
    padding: theme?.spacing(0, 1, 0, 2),
    backgroundColor: getColor({colorscheme, theme}),
    height: '28px',
    borderRadius: '14px',
    userSelect: 'none',
    transition: '0.2s',
    maxWidth: 'max-content',
    ['&:hover']: {
      backgroundColor: getHoverColor({colorscheme, theme}),
    },
  },

  [`& .${classes.title}`]: {
    color: theme?.palette.figma_gray_light_1?.main,
    fontSize: 14,
    lineHeight: '16px',
  },

  [`& .${classes.helpBox}`]: {
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  [`& .${classes.helpIcon}`]: {
    width: '16px',
    height: '16px',
  },
}));

export {classes as statusClasses, Root as StatusRoot};
